import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { Geolocation } from '@capacitor/geolocation';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const Address = () => {
  const [addressLine, setAddressLine] = useState('');
  const [landMark, setLandMark] = useState('');
  const [pinCode, setPinCode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [longitude, setLongitude] = useState('');
  const [latitude, setLatitude] = useState('');
  const [addressType, setAddressType] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedsec, setIsCheckedsec] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [locationFetched, setLocationFetched] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [checkboxModal, setCheckboxModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const applicationId = params.get('applicationId');
  const customerId = params.get('customerId');

  useEffect(() => {
    const getLocation = async () => {
      try {
        const perm = await Geolocation.checkPermissions();
        if (perm.location !== 'granted') {
          await Geolocation.requestPermissions();
        }
        const pos = await Geolocation.getCurrentPosition({ enableHighAccuracy: true });
        setLatitude(pos.coords.latitude.toString());
        setLongitude(pos.coords.longitude.toString());
        setLocationFetched(true);
      } catch {
        // Capacitor failed — try browser geolocation
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              setLatitude(pos.coords.latitude.toString());
              setLongitude(pos.coords.longitude.toString());
              setLocationFetched(true);
            },
            () => setLocationFetched(false),
            { enableHighAccuracy: true, timeout: 10000 }
          );
        } else {
          setLocationFetched(false);
        }
      }
    };
    getLocation();
  }, []);

  useEffect(() => {
    if (pinCode.length !== 6) return;
    const fetchPin = async () => {
      try {
        const res = await fetch(`${base_url}/api/postal/${pinCode}`, {
          headers: { 'Content-Type': 'application/json' },
        });
        if (res.ok) {
          const data = await res.json();
          const po = data?.[0]?.PostOffice?.[0];
          if (po) {
            setCity(po.District);
            setState(po.State);
          }
        }
      } catch {}
    };
    fetchPin();
  }, [pinCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked || !isCheckedsec) { setCheckboxModal(true); return; }
    if (!locationFetched) { alert('Please enable location to proceed.'); return; }
    if (!customerId && !applicationId) { setErrorModal(true); return; }

    setIsLoading(true);
    const idParam = customerId ? `customerId=${customerId}` : `applicationId=${applicationId}`;
    try {
      const res = await fetch(`${base_url}/api/address/addAddress?${idParam}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          landMark, pinCode: parseInt(pinCode), state, city,
          address: addressLine, longitude, latitude, addressType: parseInt(addressType),
        }),
      });
      if (res.ok) {
        navigate(`/CreditCheck?applicationId=${applicationId}&customerId=${customerId}`);
      } else {
        setErrorModal(true);
      }
    } catch {
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="Address Details" backPath="/CustomerList" />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <form onSubmit={handleSubmit}>
          <div className="app-card">
            <p className="section-title">Residential Address</p>

            <div className="field-group">
              <label className="field-label">Address Line 1 <span className="field-star">*</span></label>
              <input className="field-input" value={addressLine} onChange={e => setAddressLine(e.target.value)} required />
            </div>

            <div className="field-group">
              <label className="field-label">Landmark</label>
              <input className="field-input" value={landMark} onChange={e => setLandMark(e.target.value)} />
            </div>

            <div className="field-group">
              <label className="field-label">Pin Code <span className="field-star">*</span></label>
              <input className="field-input" maxLength={6} value={pinCode} onChange={e => setPinCode(e.target.value)} required />
            </div>

            <div className="field-group">
              <label className="field-label">City</label>
              <input className="field-input" value={city} disabled />
            </div>

            <div className="field-group">
              <label className="field-label">State</label>
              <input className="field-input" value={state} disabled />
            </div>

            <div className="field-group">
              <label className="field-label">Address Type <span className="field-star">*</span></label>
              <select className="field-select" value={addressType} onChange={e => setAddressType(e.target.value)} required>
                <option value="" hidden>Select Type</option>
                <option value="1">Permanent</option>
                <option value="2">Office</option>
                <option value="3">Present</option>
              </select>
            </div>

            <div className="field-group" style={{ background: '#f8f9ff', borderRadius: 8, padding: 10 }}>
              <p style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Location</p>
              {locationFetched ? (
                <div style={{ display: 'flex', gap: 8 }}>
                  <div style={{ flex: 1, background: '#fff', border: '1px solid #e0e0e0', borderRadius: 6, padding: '6px 10px' }}>
                    <p style={{ fontSize: 10, color: '#aaa', margin: '0 0 2px' }}>Latitude</p>
                    <p style={{ fontSize: 13, fontWeight: 600, color: '#1d2e77', margin: 0 }}>{parseFloat(latitude).toFixed(6)}</p>
                  </div>
                  <div style={{ flex: 1, background: '#fff', border: '1px solid #e0e0e0', borderRadius: 6, padding: '6px 10px' }}>
                    <p style={{ fontSize: 10, color: '#aaa', margin: '0 0 2px' }}>Longitude</p>
                    <p style={{ fontSize: 13, fontWeight: 600, color: '#1d2e77', margin: 0 }}>{parseFloat(longitude).toFixed(6)}</p>
                  </div>
                </div>
              ) : (
                <span style={{ fontSize: 12, color: '#e53935' }}>Not fetched — enable GPS</span>
              )}
            </div>
          </div>

          <div className="app-card">
            <p className="section-title">Consent</p>
            <div className="check-row">
              <input type="checkbox" checked={isChecked} onChange={e => setIsChecked(e.target.checked)} />
              <label>All information provided by me is correct and valid.</label>
            </div>
            <div className="check-row">
              <input type="checkbox" checked={isCheckedsec} onChange={e => setIsCheckedsec(e.target.checked)} />
              <label>I consent to Ujjwal Srijan and its partners for credit assessment.</label>
            </div>
          </div>

          <button type="submit" className="btn-primary-app" disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Proceed'}
          </button>
        </form>
      </div>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Something went wrong. Please try again.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setErrorModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>

      <Modal show={checkboxModal} onHide={() => setCheckboxModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Please check all consent boxes to proceed.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setCheckboxModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Address;
